import { Component, computed, inject } from '@angular/core';
import { DashboardStatsCardComponent } from '../../../components/dashboard-stats-card/dashboard-stats-card.component';
import { PackageService } from '@lib/package/package.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';

@Component({
    selector: 'app-count-requested-packages',
    imports: [
        DashboardStatsCardComponent
    ],
    templateUrl: './count-requested-packages.component.html',
    standalone: true,
    styleUrl: './count-requested-packages.component.scss'
})
export class CountRequestedPackagesComponent {

    private readonly _packageService = inject(PackageService);
    protected readonly Number = Number;

    requestedPackagesCountResult = toSignal(
        this._packageService.countPackageResponses('requested').pipe(
            catchError(() => of(null))
        )
    );

    requestedPackages = computed(() => this.requestedPackagesCountResult()?.count);

    getPackageCount(): number {
        return this.requestedPackages() && Number(this.requestedPackages()) > 0 ? Number(this.requestedPackages()) : 0;
    }

}
